module.exports = __webpack_public_path__ + "Edmodo_Labs_Logo.png?40087b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Edmodo_Labs_Logo.png
// module id = 185
// module chunks = 9